const categories = [
  "Produtos físicos",
  "Suplementos alimentares ou farmacêuticos",
  "Software/SaaS",
  "Gaming",
  "Serviços educacionais",
  "Serviços turísticos",
  "Outros serviços",
];

export default categories;
